import Swiper from "swiper/bundle";

const CardsSliderFixThree = () => {
  const fixCardsSliders = [...document.querySelectorAll('.slider-section__slider.fix-three-slides')];

  const initializeSlider = () => {
    fixCardsSliders.forEach((fixCardsSlider) => {
      const slides = [...fixCardsSlider.querySelectorAll('.swiper-slide')];
      const controls = fixCardsSlider.querySelector(".swiper-controls");

      const minSlidesForMobile = 1;
      const minSlidesForTablet = 2;
      const minSlidesForDesktop = 3;

      const shouldInitializeSlider =  (window.innerWidth >= 1024 && slides.length > minSlidesForDesktop) ||
                                      (window.innerWidth < 1024 && window.innerWidth >= 768 && slides.length > minSlidesForTablet) ||
                                      (window.innerWidth < 768 && slides.length > minSlidesForMobile);
      

      if (!shouldInitializeSlider) {
        if (controls) {
          controls.classList.add("d-none");
        }
      }

      if (shouldInitializeSlider) {
        if (controls) {
          controls.classList.remove("d-none");
        }

        const fixCardsCarousel = new Swiper(fixCardsSlider, {
          slidesPerView: 1,
          spaceBetween: 12,
          loop: true,
          scrollbar: {
            el: '.swiper-scrollbar',
          },
          navigation: {
            nextEl: '.swiper__button-next',
            prevEl: '.swiper__button-prev',
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 16,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
          }
        });
      }
    });
  };

  initializeSlider();

  window.addEventListener('resize', () => {
    fixCardsSliders.forEach((fixCardsSlider) => {
      const swiperInstance = fixCardsSlider.swiper;
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
      }
    });
    initializeSlider();
  });
};

export default CardsSliderFixThree;

